/**
 * Static agent data for the 7 AppreciativeAI coaching agents.
 * Used on the landing page and agent hub before the API is loaded.
 */
export interface AgentInfo {
  id: string;
  ordinal: number;
  name: string;
  colour: string;
  colourLabel: string;
  coreMessage: string;
  focusAreas: string[];
  description: string;
  /** Tailwind class for left border accent */
  borderClass: string;
  /** Tailwind class for the agent's light background */
  bgLightClass: string;
  /** Button variant name matching the Button component */
  buttonVariant: 'ray' | 'olympia' | 'yves' | 'gail' | 'timothy' | 'byron' | 'peter';
}

export const AGENTS: AgentInfo[] = [
  {
    id: 'ray',
    ordinal: 1,
    name: 'Ray',
    colour: '#C75B5B',
    colourLabel: 'Red',
    coreMessage: 'Be Ready',
    focusAreas: ['Stability', 'Solid ground', 'Tools & practices'],
    description: 'Build a solid foundation. Find the tools, practices, and resources you need.',
    borderClass: 'border-l-ray',
    bgLightClass: 'bg-ray-light',
    buttonVariant: 'ray',
  },
  {
    id: 'olympia',
    ordinal: 2,
    name: 'Olympia',
    colour: '#D4874D',
    colourLabel: 'Orange',
    coreMessage: 'Be Eager',
    focusAreas: ['Motivation', 'Joy', 'Rising to challenges'],
    description: 'Rediscover motivation, joy, and the lightness of rising to challenges.',
    borderClass: 'border-l-olympia',
    bgLightClass: 'bg-olympia-light',
    buttonVariant: 'olympia',
  },
  {
    id: 'yves',
    ordinal: 3,
    name: 'Yves',
    colour: '#C9A84C',
    colourLabel: 'Yellow',
    coreMessage: 'Be Steady',
    focusAreas: ['Planning', 'Certainty', 'Forward movement'],
    description: 'Plan with confidence, make decisions, and move forward steadily.',
    borderClass: 'border-l-yves',
    bgLightClass: 'bg-yves-light',
    buttonVariant: 'yves',
  },
  {
    id: 'gail',
    ordinal: 4,
    name: 'Gail',
    colour: '#5B9E6F',
    colourLabel: 'Green',
    coreMessage: 'Be Connected',
    focusAreas: ['Relationships', 'Collaboration', 'Connection'],
    description: 'Strengthen relationships, collaboration, and your sense of belonging.',
    borderClass: 'border-l-gail',
    bgLightClass: 'bg-gail-light',
    buttonVariant: 'gail',
  },
  {
    id: 'timothy',
    ordinal: 5,
    name: 'Timothy',
    colour: '#4D9E9E',
    colourLabel: 'Turquoise',
    coreMessage: 'Be Yourself',
    focusAreas: ['Self-expression', 'Uniqueness', 'Authenticity'],
    description: 'Express your authentic self and embrace what makes you unique.',
    borderClass: 'border-l-timothy',
    bgLightClass: 'bg-timothy-light',
    buttonVariant: 'timothy',
  },
  {
    id: 'byron',
    ordinal: 6,
    name: 'Byron',
    colour: '#4A7FB5',
    colourLabel: 'Blue',
    coreMessage: 'Be Open',
    focusAreas: ['New perspectives', 'Research', 'Discovery'],
    description: 'Explore new perspectives, research ideas, and discover fresh angles.',
    borderClass: 'border-l-byron',
    bgLightClass: 'bg-byron-light',
    buttonVariant: 'byron',
  },
  {
    id: 'peter',
    ordinal: 7,
    name: 'Peter',
    colour: '#7B5EA7',
    colourLabel: 'Purple',
    coreMessage: 'Be Essential',
    focusAreas: ['Mentorship', 'Legacy', 'Interdependence'],
    description: 'Mentor others, build a legacy, and contribute to something greater.',
    borderClass: 'border-l-peter',
    bgLightClass: 'bg-peter-light',
    buttonVariant: 'peter',
  },
];
